import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getTermFromState } from '../../redux/selectors/i18n'
import Title from '../../components/Title'
import TrimSelector from './TrimSelector';
import ZipCodeModal from './ZipCodeModal';
import DefaultAccordions from '../../components/Accordion/DefaultAccordions'

/**
 * Model View is the second view after the user selects a Vehicle model.
 * To proceed farther than this view the user must select a trim and have
 * entered a valid Zip Code or have one saved in the cookie
 */
class ModelView extends Component {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  };
  static defaultProps = {
    children: undefined
  };
  render() {
    const {
      title,
      description,
      children,
    } = this.props;
    return (
      <div className="model-line-container small-10 small-centered">
        <Title title={title} description={description} />
        <ZipCodeModal />
        <TrimSelector />
        {children}
        <DefaultAccordions />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  title: getTermFromState(state, 'titlePanel.title'),
  description: getTermFromState(state, 'titlePanel.description')
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ModelView);



/** WEBPACK FOOTER **
 ** ./src/pages/ModelView/index.js
 **/